import { createSelector } from 'reselect';
import { getAssets, isCIAMSyncFlag, isRefreshAssetGroups } from '../../../GeneralFilter/GeneralFilterModal/selectors';

export const getAssetGroupOverviewList = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.assetGroups?.data;
};

const getAssetGroupOverviewLoadingStatus = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.assetGroups?.loadingStatus;
};

const getPageNumber = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.assetGroups?.pageNumber;
};

const getHasMore = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.assetGroups?.hasMore;
};
const getShowThreshold = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.assetGroups?.showThreshold;
};
const getShowTrend = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.assetGroups?.showTrend;
};
const getInitialLoadDone = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.assetGroups?.initialLoadDone;
};
const getSelectedAsset = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.selectedAsset;
};

export const getModel = createSelector(
    [
        getAssetGroupOverviewList,
        getAssetGroupOverviewLoadingStatus,
        getPageNumber,
        getShowThreshold,
        getShowTrend,
        getHasMore,
        getInitialLoadDone,
        getAssets,
        getSelectedAsset,
        isCIAMSyncFlag,
        isRefreshAssetGroups
    ],
    (
        assetGroupOverviewList,
        assetGroupOverviewLoadingStatus,
        pageNumber,
        showThreshold,
        showTrend,
        hasMore,
        initialLoadDone,
        overviewAssetList,
        selectedAsset,
        refeshCIAMSync,
        refreshAssetGroups
    ) => {
        return {
            assetGroupOverviewList,
            assetGroupOverviewLoadingStatus,
            pageNumber,
            showThreshold,
            showTrend,
            hasMore,
            initialLoadDone,
            overviewAssetList,
            selectedAsset,
            refeshCIAMSync,
            refreshAssetGroups
        };
    }
);
